import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

export function FinalCTA() {
  const navigate = useNavigate()

  return (
    <section
      id="escolas"
      className="py-24 bg-brand-navy text-white relative overflow-hidden"
    >
      {/* Background patterns */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10">
        <div className="absolute right-0 top-0 w-96 h-96 bg-brand-emerald rounded-full blur-[100px] transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-brand-blue rounded-full blur-[100px] transform -translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="container mx-auto px-4 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-extrabold mb-6 tracking-tight">
          Precisa fechar uma vaga rapidamente?
        </h2>
        <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
          Pare de perder tempo triando currículos desqualificados. Comece agora
          e resolva seu problema.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            className="w-full sm:w-auto h-16 px-10 text-xl bg-brand-emerald hover:bg-emerald-500 text-white shadow-glow animate-pulse-subtle"
            onClick={() => navigate('/anunciar-vaga')}
          >
            👉 Criar vaga gratuitamente
          </Button>
        </div>

        <p className="mt-6 text-sm text-slate-400">
          Cadastro em 2 minutos • Sem cartão de crédito
        </p>
      </div>
    </section>
  )
}
